import { useEffect } from 'react';

interface SilentLoginProps {
  onCompleted: (result: boolean) => void;
}

function SilentLogin({ onCompleted }: Readonly<SilentLoginProps>) {
  useEffect(() => {
    const eventHandler = (
      e: MessageEvent<{ source: string; isLoggedIn: boolean }>,
    ) => {
      if (e?.data?.source === 'bff-silent-login') {
        globalThis.clearTimeout(timeoutId);
        onCompleted(e.data.isLoggedIn);
      }
    };

    const timeoutId = globalThis.setTimeout(() => {
      onCompleted(false);
    }, 5000);

    globalThis.addEventListener('message', eventHandler);

    return () => {
      globalThis.clearTimeout(timeoutId);
      globalThis.removeEventListener('message', eventHandler);
    };
  }, [onCompleted]);

  return (
    <iframe
      style={{ display: 'none' }}
      id="bff-silent-login"
      title="bff-silent-login"
      src="/bff/login?prompt=none"
    />
  );
}

export default SilentLogin;
